import React from 'react'
import { GeneralLedgerView } from '@layerfi/components'
import { useOutletContext } from 'react-router-dom'

import { AccountingLayout } from '../../../layouts/AccountingLayout'

export const Ledger = () => {
  const { showCustomerVendor } = useOutletContext<{
    showCustomerVendor: boolean
  }>()

  return (
    <AccountingLayout>
      <GeneralLedgerView showCustomerVendor={showCustomerVendor} />
    </AccountingLayout>
  )
}
